import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UnitService } from '@shared/services/unit.service';
import { Observable, of, pipe, Subscription } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit, OnDestroy {

  freshDeskLink: string;
  manualLink: string;
  langSub: Subscription;
  raoNumber$: Observable<string>;

  constructor(
    private unitService: UnitService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.getFreshDeskLink();
    this.getRaoNumber();
    this.setManualLinkBasedOnLanguage(this.translateService.currentLang);
    this.handleManualLink();
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
  }

  getRaoNumber(): void {
    this.raoNumber$ = this.unitService.getUnitProperties().pipe(
      take(1),
      map(res => res.raoNumber)
    );
  }


  getFreshDeskLink(): void {
    this.unitService.getUnitProperties().subscribe(res => {
      if (!!res.ippFeAssistanceLink) {
        this.freshDeskLink = res.ippFeAssistanceLink;
      }
      else {
        this.freshDeskLink = "https://enterprise-hd.infocert.it/";
      }
    });
  }

  handleManualLink() {
    this.langSub = this.translateService.onLangChange.subscribe(res => {
      this.setManualLinkBasedOnLanguage(res.lang);
    });
  }

  setManualLinkBasedOnLanguage(lang: string) {
    switch (lang) {
      case "it":
        this.manualLink = "https://knowledgecenter.infocert.digital/Home/Guida/manuale-operativo-infocert-partner-platform?lang=it";
        break;
      case "es":
      case "en":
        this.manualLink = "https://knowledgecenter.infocert.digital/Home/Guida/infocert-partner-platform-user-manual?lang=en";
        break;
      default:
        this.manualLink = "https://knowledgecenter.infocert.digital/Home/Guida/manuale-operativo-infocert-partner-platform?lang=it";
        break;
    }
  }

}
